import { userIsNotAuthenticatedRedir } from 'components/auth/hoc';
import { withTranslation } from 'react-i18next';
import { compose, withProps } from 'recompose';

import SignUp from 'pages/SignUp/styled';

const enhance = compose(
  withTranslation('Login'),
  userIsNotAuthenticatedRedir,
  withProps(({ match }) => ({
    userDataHash: match && match.params && match.params.userDataHash,
  }))
);

export default enhance(SignUp);
